import moment from 'moment'
import { $t } from '@/composables/translation'

export const formatPeriodDate = (date: string) => moment(date, 'YYYY-MM-DD').format('MMM D, YYYY')

// A one-week period has a week number. A whole calendar month is named. Any other period, such as one saved
// before the rule applied, is labelled by its dates alone.
export const paymentRequestPeriodLabel = (
  isoWeek: number | null,
  startDate: string,
  endDate: string,
): string => {
  const start = formatPeriodDate(startDate)
  const end = formatPeriodDate(endDate)

  if (isoWeek !== null) {
    return $t('Week :week (:start - :end)', { week: isoWeek, start, end })
  }

  const firstDay = moment(startDate, 'YYYY-MM-DD')

  if (firstDay.date() === 1 && moment(endDate, 'YYYY-MM-DD').isSame(firstDay.clone().endOf('month'), 'day')) {
    return $t(':month (:start - :end)', { month: firstDay.format('MMMM YYYY'), start, end })
  }

  return `${start} - ${end}`
}
